module.exports = __webpack_public_path__ + "static/media/34.01c2559f.JPG";